class CultureHouseStoryFilm extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('[data-film-play]');
    this.muteButton = this.querySelector('[data-film-mute]');
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!this.video) return;

    this.playButton?.addEventListener('click', this.togglePlayback);
    this.muteButton?.addEventListener('click', this.toggleMute);
    this.video.addEventListener('play', this.syncPlayback);
    this.video.addEventListener('pause', this.syncPlayback);
    this.video.addEventListener('volumechange', this.syncMute);

    this.observer = new IntersectionObserver(this.handleIntersection, {
      threshold: 0.35,
    });
    this.observer.observe(this);

    if (this.hasAttribute('data-autoplay')) {
      this.loadVideo();
      if (!this.reduceMotion.matches) this.play();
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.playButton?.removeEventListener('click', this.togglePlayback);
    this.muteButton?.removeEventListener('click', this.toggleMute);
    this.video?.removeEventListener('play', this.syncPlayback);
    this.video?.removeEventListener('pause', this.syncPlayback);
    this.video?.removeEventListener('volumechange', this.syncMute);
  }

  loadVideo() {
    if (this.hasAttribute('data-loaded')) return;

    this.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    this.video.load();
    this.setAttribute('data-loaded', '');
  }

  handleIntersection = ([entry]) => {
    if (entry.isIntersecting) {
      this.loadVideo();
      if (!this.reduceMotion.matches && !this.userPaused) this.play();
      return;
    }

    this.video.pause();
  };

  play = async () => {
    try {
      await this.video.play();
    } catch {
      this.syncPlayback();
    }
  };

  togglePlayback = () => {
    this.loadVideo();

    if (this.video.paused) {
      this.userPaused = false;
      this.play();
    } else {
      this.userPaused = true;
      this.video.pause();
    }
  };

  toggleMute = () => {
    this.video.muted = !this.video.muted;
  };

  syncPlayback = () => {
    const isPlaying = !this.video.paused;
    this.toggleAttribute('data-playing', isPlaying);
    this.playButton?.setAttribute('aria-pressed', String(isPlaying));
    this.playButton?.setAttribute('aria-label', isPlaying ? 'Pause film' : 'Play film');
  };

  syncMute = () => {
    this.toggleAttribute('data-muted', this.video.muted);
    this.muteButton?.setAttribute('aria-pressed', String(this.video.muted));
    this.muteButton?.setAttribute('aria-label', this.video.muted ? 'Unmute film' : 'Mute film');
  };
}

if (!customElements.get('culture-house-story-film')) {
  customElements.define('culture-house-story-film', CultureHouseStoryFilm);
}
